import React from 'react'

import LoadingSkeleton from './LoadingSkeleton'

type CardProps = {
  label: string
  loading?: boolean
  onClick?: () => void
  percentage?: boolean
  stringValue?: string | undefined
  subLabel?: string
  value?: number | undefined
}
export const Card = ({
  value,
  stringValue,
  label,
  loading = false,
  onClick,
  percentage = false,
  subLabel,
}: CardProps) => {
  return (
    <>
      {loading ? (
        <LoadingSkeleton />
      ) : (
        <div
          className={`flex h-24 flex-col  items-stretch justify-center rounded-2xl bg-black-3 text-center ${
            !!onClick ? ' cursor-pointer' : ''
          }`}
          onClick={() => onClick && onClick()}
          role="presentation"
        >
          {percentage ? (
            <h1 className="mb-1 text-3xl" style={{ fontWeight: 600 }}>
              {value?.toFixed(2) || '0.00'}
              {'%'}
            </h1>
          ) : (
            <h1 className="mb-1 text-3xl" style={{ fontWeight: 600 }}>
              {value}
              {stringValue}
            </h1>
          )}
          <p className="text-sm">{label}</p>
          {subLabel && <p className="text-xs">{subLabel}</p>}
        </div>
      )}
    </>
  )
}
